export class AuthUser {
  accesosNegocio?: [];
  activo?: boolean;
  bloqueo?: boolean;
  correo?: string;
  datosUsuario: any;
  fecha_actualizacion?: string;
  fecha_creacion?: string;
  id: number;
  identificador: string;
  imagen: any;
  nombre?: string;
  perfilId?: number;
  posicion: any;
  roles?: Rol[];
  token?: string;
  username: any;
  usuario_actualizacion?: string;
  usuario_creacion?: string;
  proveedores?: ProveedorUsuario[];

  constructor(){
    this.id = 0;
    this.identificador = "";
  }
}

export class Rol {
  activo?: boolean;
  fecha_actualizacion: any;
  fecha_creacion?: string;
  funcionalidades?: Funcionalidad[];
  id: number;
  identificador: string;
  nombre?: string;
  usuario_actualizacion: any;
  usuario_creacion: any;

  constructor(){
    this.id = 0;
    this.identificador = "";
  }
}

export class Funcionalidad {
  codigo?: string;
  descripcion?: string;
  fecha_actualizacion: any;
  fecha_creacion?: string;
  icono?: string;
  id: number;
  identificador: string;
  seccion?: string;
  tipo?: string;
  url?: string;
  usuario_actualizacion: any;
  usuario_creacion: any;
  subitems: any;

  constructor(){
    this.id = 0;
    this.identificador = "";
  }
}

export class ProveedorUsuario {
  correo?: string;
  id: number;
  identificador: string;
  nombre?: string;
  numero?: string;
  rfc?: string;
  es_repse?: boolean;
  bloqueo_repse: boolean;
  bloqueo_repse_inicial: boolean;
  bloqueoComplementoPago: boolean;
  tieneRepseNuevo: boolean;
  tieneRepseNuevoInicial: boolean;
  periodosPendientes?: string;

  constructor(){
    this.id = 0;
    this.identificador = "";
    this.bloqueo_repse = false;
    this.bloqueo_repse_inicial = false;
    this.bloqueoComplementoPago = false;
    this.tieneRepseNuevo = false;
    this.tieneRepseNuevoInicial = false;
    this.periodosPendientes = "";
  }
}
